import { render, staticRenderFns } from "./TransactionConfigList.vue?vue&type=template&id=a8c668ee&scoped=true&"
import script from "./TransactionConfigList.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c668ee",
  null
  
)

export default component.exports